import setReduxAction from 'modules/redux/actions/set'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import removeReferenceAction from 'modules/training/modules/references/actions/remove'
import addReferenceAction from 'modules/training/modules/references/actions/add'
import { getObjectUtil } from 'packages/src'

/**
 * Sets the `value` at the given `payload.path`.
 * @param {Object} params
 *        {string} params.path
 *        {String[]} [params.paths]
 *        {string} params.value
 *        {String[]} [params.values]
 *        {Object} [params.options]
 */
function setIdReduxAction (params) {
  return (dispatch, getState) => {
    const { payload } = params
    const {
      instance,
      path
    } = payload
    // Remove the current reference
    const domainPath = path.slice(0, path.indexOf('.'))
    const currentId = getObjectUtil(getState(), path)
    const currentInstance = getObjectUtil(getState(), `${domainPath}.data.${currentId}`)
    if (currentInstance) {
      dispatch(
        removeReferenceAction({
          instance: currentInstance,
          referencePath: path
        })
      )
    }
    dispatch(
      setReduxAction({
        type: params.type,
        payload: {
          path,
          value: instance ? getIdReduxUtil(instance) : null
        }
      })
    )
    // Add the reference path
    if (instance) {
      dispatch(
        addReferenceAction({
          instance,
          referencePath: path
        })
      )
    }
  }
}

export default setIdReduxAction
